import './TicketChickenTest.scss';
import { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { updateTicket, reopenTicket } from '../../../../slices/TicketSlice';
import { toast } from 'react-toastify';

function TicketChickenTest({ onClose, mode, ticketId }) {
  const dispatch = useDispatch();

  const [confirmationText, setConfirmationText] = useState("");

  const isReopening = mode === "reopen";

  const message = isReopening
    ? "Are you sure you want to re-open this ticket?"
    : "Type CLOSE below to confirm closing this ticket.";

  const actionText = isReopening ? "Reopen" : "Close Ticket";

  const isConfirmationValid =
    isReopening || confirmationText.trim() === "CLOSE";

  async function handleAction() {
    try {
      if (isReopening) {
        await dispatch(reopenTicket(ticketId)).unwrap();
        toast.success("Ticket reopened!");
      } else {
        await dispatch(
          updateTicket({
            ticketId,
            updates: { status: "CLOSED" },
          })
        ).unwrap();

        toast.success("Ticket closed!");
      }

      onClose();
    } catch (err) {
      toast.error(err || "Action failed");
    }
  }

  return (
    <div className="chicken-test-container">
      <div className="chicken-test-message">

        <p>{message}</p>

        {!isReopening && (
          <TextField
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value)}
            placeholder="Type CLOSE"
            fullWidth
            size="small"
            margin="normal"
            inputProps={{
              "data-testid": "close-confirmation-input",
            }}
            helperText={
              <>
                Type CLOSE exactly to close this ticket PERMANENTLY.
                <br />
                This action cannot be undone.
              </>
            }
          />
        )}

        <div className="chicken-test-buttons">
          <Button
            onClick={onClose}
            id="cancel-button"
            data-testid="cancel-chicken-test-button"
          >
            Cancel
          </Button>

          <Button
            onClick={handleAction}
            id="complete-button"
            data-testid="complete-chicken-test-button"
            disabled={!isConfirmationValid}
          >
            {actionText}
          </Button>
        </div>

      </div>
    </div>
  );
}

export default TicketChickenTest;